import React, { Dispatch, SetStateAction } from 'react'

import NumbersRangeSelect from '@components/NumbersRangeSelect'
import { MetaFilterTypes, NumbersRange } from '@modules/search/types'

export interface DateRangeSelectProps {
  eventsDatesRange: NumbersRange
  selectedDateFrom?: number
  selectedDateTo?: number
  setDateRangeSelectEnd: Dispatch<SetStateAction<number>>
  setDateRangeSelectStart: Dispatch<SetStateAction<number>>
  setSelectedType?: Dispatch<SetStateAction<MetaFilterTypes>>
  isSelected?: boolean
}

const DateRangeSelect = (props: DateRangeSelectProps) => {
  const {
    eventsDatesRange,
    selectedDateFrom,
    selectedDateTo,
    setDateRangeSelectEnd,
    setDateRangeSelectStart,
    setSelectedType,
    isSelected,
  } = props

  const handleChangeDateRange = (minDate: number, maxDate: number) => {
    if (!isSelected && setSelectedType) {
      setSelectedType(MetaFilterTypes.BY_DATE_RANGE)
    }

    setDateRangeSelectStart(minDate)
    setDateRangeSelectEnd(maxDate)
  }

  return (
    <NumbersRangeSelect
      maxValue={eventsDatesRange.max}
      minValue={eventsDatesRange.min}
      selectedStartValue={selectedDateFrom}
      selectedEndValue={selectedDateTo}
      onChange={handleChangeDateRange}
    />
  )
}

export default DateRangeSelect
